var watchlistEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Annuleren",
	title: "Volglijst bewerken",
	nameInputLabel: "Naam Volglijst",
	nameInputTip: "Max. 100 characters – Geldige tekens: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	placeholder: "Nieuwe Naam",
	validationErrors: {
		name: {
			invalidInput: "Naam is ongeldig. Max 100 karakters – Geldige tekens: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var nl = {
	watchlistEdit: watchlistEdit
};

export { nl as default, watchlistEdit };
